import { useMemo } from 'react'
import { Progress } from '@/components/ui/progress.tsx'
import { t } from 'i18next'
import dayjs from 'dayjs'

interface PracticeSetResultSummary {
	items_count: number
	correct_count: number
	practiced_at: string
}

const PracticeSetResultSummary = ({ items_count, correct_count, practiced_at }: PracticeSetResultSummary) => {
	const percentage = useMemo(() => {
		return (correct_count * 100) / items_count
	}, [correct_count, items_count])

	return (
		<div className="flex flex-col w-full px-3 my-1 gap-2">
			<div className="font-display text-center text-lg font-bold text-black dark:text-white select-none">
				{t('Practice Results')}
			</div>
			<div className="flex flex-row justify-center items-center">
				<div className="w-3/5 text-sm">
					<div className="flex flex-col">
						<span className="mb-0.5 font-semibold">{t('Date')}:</span>
						<span className="font-normal">
							{dayjs.utc(practiced_at).local().format('YYYY/MM/DD HH:mm')}
						</span>
					</div>
				</div>
				<div className="w-full flex flex-col justify-center items-center">
					<div className="text-sm mb-0.5">
						<span className="font-semibold mx-0.5">{correct_count}</span>/
						<span className="mx-0.5">{items_count}</span>
					</div>
					<Progress value={percentage} className="w-full" />
				</div>
			</div>
		</div>
	)
}

export default PracticeSetResultSummary
